import { Button, Modal, Input, Form, Select, message, Col, Row, DatePicker, Divider, Pagination, List, Skeleton } from 'antd';
import moment from 'moment';
import axios from 'axios';

import { downloadPdfFile, requestError } from '../../controllers/functions';
import { useEffect, useState } from 'react';
import { useCallback } from 'react';
import { getMonthsBackwards } from '../../pages/Schools';

const { Option } = Select;

const SubscriptionReceiptModal = ({ show, setOpenModal, record, extractTokenFromUrl }) => {

  const [form] = Form.useForm();
  const [paymentForm] = Form.useForm();
  const [ currences, setCurrencies ] = useState([]);
  const [ payments, setPayments ] = useState([]);
  const [ payment, setPayment ] = useState({});
  const [ savingPayment, setSavingPayment ] = useState(false);
  const [ loadingPayments, setLoadingPayments ] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 4; 
  

  const getCurrences = useCallback(() => {
    axios.get( process.env.REACT_APP_API_URI+"/school/fees/currencies", {headers: { authorization : `Bearer ${extractTokenFromUrl()}`}} ).then( done =>{
        setCurrencies(done.data);
      }).catch( error => {
          requestError({error});
      })
  }, [extractTokenFromUrl]);

  const getPayments = useCallback(() => {
    setLoadingPayments(true);
    const f = {
            currentPage,
            pageSize
        }

    const q = new URLSearchParams(f).toString();

    axios.get( process.env.REACT_APP_API_URI+`/schools/subscriptions/payments/${record?.id}?${q}`, {headers: { authorization : `Bearer ${extractTokenFromUrl()}`}} ).then( done =>{
        setPayments(done.data);
      }).catch( error => {
          requestError({error});
      }).finally( done =>{
        setLoadingPayments(false);
      })
  }, [currentPage, extractTokenFromUrl, record?.id]);

  useEffect( () => {
    if(show) {
      getCurrences();
      paymentForm.resetFields();
      form.resetFields();
      getPayments();
    }
  }, [form, getCurrences, getPayments, paymentForm, show])

  const savePayment = (v) => {
    setSavingPayment(true)
    const url = payment?.id ? process.env.REACT_APP_API_URI+`/schools/subscriptions/payments/${payment?.id}` : process.env.REACT_APP_API_URI+"/schools/subscriptions/payments"
    axios.post( url ,{ ...v, schoolId : record?.id }, {headers: { authorization : `Bearer ${extractTokenFromUrl()}`}} ).then( done =>{
        message.success(done.data.res);
        getPayments();
        paymentForm.resetFields();
        setPayment({})
    }).catch( error => {
        requestError({error});
    }).finally( done =>{
      setSavingPayment(false)
    })
  }


  return (
    <>
    
      <Modal 
      title={`${record?.name} Invoice(s) and Payments` }
      open={show} 
      onOk={()=>setOpenModal(false)} 
      onCancel={()=>setOpenModal(false)}
      footer={[
        <Button key="cancel" type=""  onClick={()=>{setOpenModal(false)}} danger>
            Close
        </Button>
      ]}
      >
        <Divider style={{ marginTop : 2 }}/>
      <Form
      layout="vertical"
      className="row-col"
      onFinish={(v)=> {
        v = {
            ...v,
            date : v.date,
            schoolId : record.id
        }
        const queryParams = new URLSearchParams(v).toString();
        const url = process.env.REACT_APP_API_URI+`/schools/invoice?${queryParams}`
          downloadPdfFile({ url });
      }}
      id="download-subscription-inv" 
      form={form}
      >
        <Row gutter={1}>
          {/* First column expands */}
          <Col flex="auto">
            <Form.Item
              name="date"
              style={{ marginRight: 5 }}
              rules={[
                { required: true, message: "Please input your Parent Name!" },
              ]}
            >
              <Select
                showSearch
                placeholder="Select Month"
                optionFilterProp="children"
                style={{ height: 29, width: "100%" }}
              >
                {getMonthsBackwards().map((item) => (
                  <Option value={item} key={item}>
                    {moment(item, "MM-YYYY").format("MMM YYYY")}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          {/* Button column only fits content */}
          <Col flex="none">
          <Form.Item>
            <Button
              key="submit"
              htmlType="submit"
              form="download-subscription-inv"
              style={{
                height: 29
              }}
              type="dashed"
            >
              Download
            </Button>
            </Form.Item>
          </Col>
        </Row>
        </Form>

        <Divider style={{ marginTop : 0}}/>
      <Form
      layout="vertical"
      className="row-col"
      onFinish={savePayment}
      id="subscription-payment-form" 
      form={paymentForm}
      >
        <Row gutter={1}>
          {/* First column expands */}
          <Col flex="auto">
            <Form.Item
              name="date"
              style={{ marginRight: 5 }}
              rules={[
                { required: true, message: "Select Month!" },
              ]}
            >
              <Select
                showSearch
                placeholder="Month"
                optionFilterProp="children"
                style={{ height: 29, width: "100%" }}
              >
                {getMonthsBackwards().map((item) => (
                  <Option value={item} key={item}>
                    {moment(item, "MM-YYYY").format("MMM YYYY")}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col flex="none">
            <Form.Item
              name="currencyId"
              style={{ marginRight: 5 }}
              rules={[
                { required: true, message: "Select Month!" },
              ]}
            >
              <Select
                showSearch
                placeholder="Currency"
                optionFilterProp="children"
                style={{ height: 29, width: "100%" }}
              >
                {currences.map((currency) => (
                  <Option value={currency?.id} key={currency?.id}>
                    {currency?.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col flex="none">
            <Form.Item
              name="amount"
              style={{ marginRight: 5 }}
              rules={[
                { required: true, message: "Please input amount!" },
              ]}
            >
              <Input placeholder='$0000' style={{ width : 70, height : 29 }}/>
            </Form.Item>
          </Col>

          <Col flex="none">
          <Form.Item>
            <Button
              key="submit"
              htmlType="submit"
              form="subscription-payment-form"
              style={{
                height: 29
              }}
              type="dashed"
              loading={savingPayment}
            >
              +
            </Button>
            </Form.Item>
          </Col>
        </Row>
        </Form>

        <Divider style={{ marginTop : 0}}/>

        <Payments
          payments={payments}
          loading={loadingPayments}
          pageSize={pageSize}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />

      </Modal>
    </>
  );
};

export default SubscriptionReceiptModal;

const Payments = ({ loading,  payments, currentPage, pageSize, setCurrentPage  }) => {

  return <>
  <List
        dataSource={payments.payments || []}
        loading={loading}
        renderItem={(item) => (
          <List.Item
            actions={[
              <a key="list-loadmore-edit" style={{ fontSize: 11.5 }}>
                {item.currency?.name} {parseFloat(item?.amount).toFixed(2)}
              </a>,
            ]}
            style={{ fontSize: 13 }}
          >
            <Skeleton avatar title={false} loading={item?.loading} active>
              <List.Item.Meta
                title={
                  <a href="#" style={{ fontSize: 12 }}>
                    {item.month} - Payment for Invoice - {item?.invoiceNumber} 
                  </a>
                }
                description={
                  <div style={{ color: "#888" }}>
                    <div style={{ fontSize: 12, display : "flex", gap : 10 }}>
                      <div>
                        <span style={{ fontWeight : 600 }}>date:{" "}</span>
                        <span>{moment(item?.date).format("ddd[,] DD MMM YYYY")}</span>
                      </div>
                      <div>
                        <span style={{ fontWeight : 600 }}>status:{" "}</span>
                        <span>{item.status}</span>
                      </div>
                      
                    </div>

                    <div style={{ marginTop: "0.6rem" }}>
                      <Button
                        size="small"
                        type="link"
                        // onClick={()=>{
                        //   setOpenDownloadInvoiceModal(true);
                        //   setSchool(item);
                        // }} 
                      >
                        <span style={{ fontSize: 11 }}> Edit </span>
                      </Button>

                      <Button
                        size="small"
                        type="link"
                        // onClick={() => {
                        //   Modal.confirm({
                        //     title: "Are you sure you want to delete this?",
                        //     onCancel: () => {},
                        //     onOk: () => deleteSchool(item?.id),
                        //   });
                        // }}
                        danger
                      >
                        <span style={{ fontSize: 11 }}>Delete</span>
                      </Button>
                    </div>
                  </div>
                }
              />
            </Skeleton>
          </List.Item>
        )}
      />

      {/* Pagination */}
      {payments?.totalPayments > pageSize && (
        <div style={{ textAlign: "right", marginTop: "1rem" }}>
          <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={payments?.totalPayments}
            onChange={(page) => setCurrentPage(page)}
            size="small"
          />
        </div>
      )}
  </>
}